<template>
  <span>
    <template v-if="finished">
      <slot name="finish">&nbsp;{{ $t('Čas vypršel') }}</slot>
    </template>
    <template v-else>
      <slot name="process" :timeObj="timeObj">
        &nbsp;{{ formatted }}
      </slot>
    </template>
  </span>
</template>

<script>
import ServerClock from '@/libs/ServerClock'

export default {
  name: 'CartCountdown',
  props: {
    endTime: { type: [String, Number, Date], required: true },
  },
  emits: ['finish'],
  data () {
    return {
      // MOB-100: the countdown target is a server-issued `expireAt`, so the "now" it is
      // measured against must be the server's, not the device's. ServerClock applies the
      // offset measured when the draft was created; without a measurement it is Date.now().
      now: ServerClock.now(),
      timer: null,
      finished: false,
      emittedFinish: false,
    }
  },
  computed: {
    targetMs () {
      const t = this.endTime
      if (t instanceof Date) return t.getTime()
      if (typeof t === 'number') return t
      return new Date(t).getTime()
    },
    remainingMs () {
      return Math.max(0, this.targetMs - this.now)
    },
    timeObj () {
      const ms = this.remainingMs
      const totalSec = Math.floor(ms / 1000)
      const d = Math.floor(totalSec / 86400)
      const h = Math.floor((totalSec % 86400) / 3600)
      const m = Math.floor((totalSec % 3600) / 60)
      const s = totalSec % 60
      const pad = (n) => String(n).padStart(2, '0')
      return {
        d: String(d),
        h: pad(h),
        m: pad(m),
        s: pad(s),
        ms: String(ms % 1000).padStart(3, '0'),
        leftTime: ms,
      }
    },
    formatted () {
      return `${this.timeObj.m}:${this.timeObj.s}`
    },
  },
  watch: {
    endTime: {
      immediate: true,
      handler () {
        this.finished = false
        this.emittedFinish = false
        this.tick()
      },
    },
  },
  mounted () {
    this.timer = setInterval(this.tick, 1000)
  },
  beforeUnmount () {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    tick () {
      this.now = ServerClock.now()
      if (this.remainingMs === 0 && !this.emittedFinish) {
        this.finished = true
        this.emittedFinish = true
        this.$emit('finish')
      }
    },
  },
}
</script>
